import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitIntake = (payload) =>
  apiClient.post("/intake", payload).then((r) => r.data);

export const submitContact = (payload) =>
  apiClient.post("/contact", payload).then((r) => r.data);

export const logCookieConsent = (payload) =>
  apiClient.post("/cookie-consent", payload).then((r) => r.data);
